// extracted by mini-css-extract-plugin
module.exports = {"ArrowsWrapper":"az_ADc","Arrow":"az_BDc","Visible":"az_CDc","Prev":"az_DDc","Next":"az_EDc","FlippedIcon":"az_FDc","PrevIcon":"az_GDc"};